import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=0a60f1d5&scoped=true"
import script from "./MessageNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MessageNotification.vue?vue&type=style&index=0&id=0a60f1d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60f1d5",
  null
  
)

export default component.exports